import React from 'react';
import PropTypes from 'prop-types';

class CheckboxEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || false,
			updated: false
		};
	}

	componentDidMount() {
		const { row, col, rowIndex, columnIndex, onStartEdit } = this.props;
		if (typeof onStartEdit === 'function') {
			onStartEdit(row, col, rowIndex, columnIndex);
		}
	}

	componentWillUnmount() {
		const { onUpdate } = this.props.editorProps;
		const { value, updated } = this.state;

		if (!updated) {
			onUpdate(value);
		}
	}

	getValue = () => this.state.value;

	onChange = event => {
		const { onUpdate } = this.props.editorProps;
		const updated = true;
		const value = event.target.checked;
		this.setState({ value, updated }, () => onUpdate(value));
	};

	render() {
		const { rowIndex, columnIndex } = this.props;
		const { value } = this.state;
		const key = `checkbox-${rowIndex}-${columnIndex}`;

		return <input type="checkbox" key={key} checked={value} id={`checkbox-${rowIndex}-${columnIndex}`} onChange={this.onChange} />;
	}
}

CheckboxEditor.propTypes = {
	value: PropTypes.bool,
	rowIndex: PropTypes.number.isRequired,
	columnIndex: PropTypes.number.isRequired
};

CheckboxEditor.defaultProps = {
	value: false
};

export default CheckboxEditor;
